import * as angular from 'angular';
import ProcedureEditorBridge from './ProcedureEditorBridge';

angular
  .module('flowingly.runner.procedures')
  .component('procedureEditor', ProcedureEditorBridge);
